<script>
import moment from 'moment';
import * as API from '../api/comments';
import toHTML from 'linkifyjs/html';

export default {
    name: 'CpReplyItem',
    directives: {
        margin: require('../directives/margins').margin,
        marginBottom: require('../directives/margins').marginBottom,
        marginTop: require('../directives/margins').marginTop,
    },
    components: {
        CpIcon: require('../icon').default,
        CpButton: require('../button').default,
        PersonIcon: require('../social-feed/icons').default,
        CpBaseSvgIcon: require('../base-svg-icon').default,
        CpImage: require('../image').default,
        CpCommentInput: require('./comment-input').default,
        CpGrid: require('../grid').default,
        CpGridItem: require('../grid-item').default,
        GifIcon: require('../social-feed/icons/gif').default,
        CpDialog: require('../dialog').default,
        CpModalGifs: require('../gifs/modal-gifs').default,
        CpWysiwygInput: require('../inputs/wysiwyg').default,
        CpCloudinaryImageInput: require ('../inputs/cloudinary-image').default,
        CpCloudinaryVideoInput: require ('../inputs/cloudinary-video').default,
        VueSimpleSpinner: require('../vue-simple-spinner').default,
        CpTextEditor: require('../components/TextEditor').default,
        OpenGraphPreview: require('../components/OpenGraphPreview').default,
        getEmbedUrl: require('../mixins/utils.js').default,
        socialMediaName: require('../mixins/utils.js').default,
        removeContentUrl: require('../mixins/utils.js').default,
        isAnchorTag: require('../mixins/utils.js').default,
        CpShowImageInCard: require('../components/ShowImageInCard').default,
        CpDisplaySocialMedia: require('../components/DisplaySocialMedia').default,
    },
    props: {
        data: { type: Object, default: () => {} },
        type: String,
        commentId: [String, Number],
        deleteComment: Function,
        authUser: Object,
        loadReplies: Function,
    },
    data() {
        return {
            comment: this.data.comment,
            gif: this.data.gif,
            image: this.data.image,
            video: this.data.video,
            isEditingReply: false,
            replyComment: false,
            loading: false,
            inputDisabled: true,
            currentCommentSelected: null,
            endorseClass: 'content-2 reply mr-5 btn',
            protestClass: 'content-2 reply mr-5 btn',
            endorseComment: this.data.react === 'endorse',
            protestComment: this.data.react === 'protest',
            showGifsModal: false,
            media: false,
            sendFailed: false,
            loadingDelete: false,
            loadingUpdate: false,
            showMore: true,
            contentLength: 0,
        };
    },
    methods: {
        async sendReply({ opinion: comment, gif, image, video }) {
            this.loading = true;
            await API.comment(this.data.data_id, this.type, { comment, reply_id: this.commentId, gif, image, video })
                .then(() => {
                    this.loadReplies(0);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
            this.replyComment = false;
        },
        reactedComment() {
            if (!this.authUser) {
                window.location.href = '/user/login';
            } else {
                let react = 'none';
                if (this.endorseComment && !this.protestComment) {
                    react = 'endorse';
                }
                if (!this.endorseComment && this.protestComment) {
                    react = 'protest';
                }
                API.commentReacted(this.data.id, this.type, { react: react })
                    .then((response) => {})
                    .catch((error) => {
                        onError(error);
                    });
            }
        },
        handleReply() {
            this.replyComment = !this.replyComment;
        },
        handleEndorseComment() {
            this.endorseComment = !this.endorseComment;
            if (this.protestComment) {
                this.protestComment = false;
            }
            this.reactedComment();
        },
        handleProtestComment() {
            this.protestComment = !this.protestComment;
            if (this.endorseComment) {
                this.endorseComment = false;
            }
            this.reactedComment();
        },
        submitReply(e, { opinion: comment, gif, image, video }) {
            e.preventDefault();
            if (!comment) {
                comment = '';
            } else {
                comment = comment.replace(/&nbsp;/g, '');
            }

            if (image || video || gif || comment.trim() !== '') {
                this.loadingUpdate = true;
                this.loadingDelete = true;
                comment !== '' ? comment : null;
                API.updateComment(this.data.id, { comment, gif, image, video })
                    .then(() => {
                        this.loadReplies(0);

                        this.loadingUpdate = false;
                        this.loadingDelete = false;
                        this.sendFailed = false;
                    })
                    .catch(error => {
                        this.loadingUpdate = false;
                        this.loadingDelete = false;
                        this.sendFailed = true;
                        console.warn(error);
                    });
                this.inputDisabled = true;
                this.isEditingReply = false;
                this.currentCommentSelected = null;
            } else {
                this.sendFailed = true;
            }
        },
        handleEditReply(id) {
            this.currentCommentSelected = id;
            this.inputDisabled = false;
            this.isEditingReply = true;
        },
        handleEditState() {
            this.isEditingReply = !this.isEditingReply;
        },
        handleGifsModal() {
            this.showGifsModal = !this.showGifsModal;
        },
        selectedGif(gif) {
            return (this.gif = gif.images.downsized.url);
        },
        removeMedia() {
            this.data.image = null;
            this.image = null;
            this.data.video = null;
            this.video = null;
            this.gif = null;
        },
        handleShowMore() {
            this.showMore = !this.showMore;
        },
    },

    mounted() {
        if (this.isAnchorTag(this.comment)) {
            const contentWithoutUrl = this.removeContentUrl(this.comment);
            this.contentLength = contentWithoutUrl.length;
        } else {
            this.contentLength = this.comment.length;
        }
    },

    computed: {
        userAdmin() {
            return this.$root.authUser && this.$root.authUser.is_admin;
        },
        content() {
            return this.comment && !this.comment.includes('<img src="') ?
                this.$root.isMobile
                    ? this.contentLength > 150 && this.showMore
                        ? toHTML(this.comment.substring(0, 150) + '...')
                        : toHTML(this.comment)
                    : this.$root.isSmallDesktop
                    ? this.contentLength > 400 && this.showMore
                        ? toHTML(this.comment.substring(0, 400) + '...')
                        : toHTML(this.comment)
                    : this.contentLength > 550 && this.showMore
                        ? toHTML(this.comment.substring(0, 550) + '...')
                        : toHTML(this.comment)
                : this.comment;
        },
        mediaData() {
            if (this.image || this.video || this.gif) {
                this.media = true;
            } else {
                this.media = false;
            }
            
            return this.media;
        },
        showButtonMore() {
            return (
                ((this.$root.isMobile && this.contentLength > 150) ||
                    (this.$root.isSmallDesktop && this.contentLength > 400) ||
                    (!this.$root.isMobile && !this.$root.isSmallDesktop && this.contentLength > 550)) &&
                !this.isEditingReply && !this.comment.includes('<img src="')
            );
        },
        videoEmbedUrl() {
            return this.getEmbedUrl(this.video);
        },
    },
};
</script>

<template>
    <div class="social-feed-post-wrapper">
        <cp-grid>
            <cp-grid-item
                :span="$root.isMobile ? 2 : 1"
                :margin-right="$root.isMobile ? 15 : 0"
                style="display: flex; justify-content: center; margin-left: 3%"
            >
                <a :href="'/profile/' + data.slug" style="text-decoration: none">
                    <cp-image
                        class="user-image"
                        :src="data.profile_image"
                        circular
                        :alt="'MW'"
                        :width="$root.isMobile ? '25' : '40'"
                        :height="$root.isMobile ? '25' : '40'"
                        style="position: initial;"
                    ></cp-image>
                </a>
            </cp-grid-item>
            <cp-grid-item :span="$root.isMobile ? 9.5 : 10.5" class="mini-recipient" style="display: block">
                <cp-grid>
                    <cp-grid-item :span="isEditingReply || $root.isMobile ? 12 : 10">
                        <div class="reply-item-header">
                            <a :href="'/profile/' + data.slug"
                                ><span class="profile-name heading-4" style="margin: 0px 3px 0px 5px"
                                    >{{ data.name }}
                                    <cp-base-svg-icon
                                        v-if="data.type_comment == 'endorse'"
                                        :width="20"
                                        :height="20"
                                        viewBox="0 0 32 15"
                                        :icon-color="'currentColor'"
                                        :stroke-color="'none'"
                                    >
                                        <endorse-icon />
                                    </cp-base-svg-icon> </span
                            ></a>
                            <CpButton v-if="isEditingReply" noborder @click="handleEditState" :disabled="loadingUpdate" style="background: transparent;">Cancel</CpButton>
                        </div>
                        <div v-if="loadingUpdate" class="heading-4 text-center">
                            <vue-simple-spinner v-margin="1" />Loading...
                        </div>
                        <div v-else>
                            <CpTextEditor
                                v-if="isEditingReply"
                                :text="comment"
                                placeholder="Write a reply..."
                                @sendMessage="submitReply"
                                :withBackground="false"
                                :primaryBtnType="false"
                                submitButtonTitle="Save"
                                :loadingSend="loading"
                            />
                            <p v-else-if="content" style="overflow-wrap: anywhere; font-size: 18px;" class="content-2 box-comment" v-html="content">
                            </p>
                            <p v-if="content && showButtonMore" class="button-show-more" @click="handleShowMore">
                                {{ showMore ? 'Read More' : 'Read Less' }}
                            </p>

                            <div v-if="image" style="margin: 10px 5px 0">
                                <CpShowImageInCard
                                    v-if="data.image"
                                    :image="data.image"
                                    altMessage="Reply image"
                                    v-margin-top=".5"
                                />
                                <cp-cloudinary-image-input
                                    v-else-if="image"
                                    :width="680"
                                    :height="680"
                                    :margin="0"
                                    :initial-value="image"
                                    v-model="image"
                                    :icon="true"
                                    style="position: initial;"
                                    class="comment"
                                ></cp-cloudinary-image-input>
                            </div>
                            <div v-else-if="video" style="margin: 10px 5px 0">
                                <CpDisplaySocialMedia v-if="videoEmbedUrl !== null" :video="video" />
                                <video v-else-if="data.video" controls preload="metadata" style="max-height: 400px; max-width: 100%;">
                                    <source :src="`${video}#t=0.2`" type="video/mp4" />
                                </video>
                                <cp-cloudinary-video-input
                                    v-else-if="video"
                                    :width="1000"
                                    :height="500"
                                    :margin="0"
                                    :initial-value="video"
                                    v-model="video"
                                    :icon="true"
                                    style="position: initial"
                                    class="comment"
                                ></cp-cloudinary-video-input>
                            </div>
                            <div v-else-if="gif" style="margin: 10px 5px 0">
                                <img class="gif" :src="gif" alt="" />
                            </div>
                            <div v-if="(data.image || data.video || gif) && isEditingReply" style="margin-left: 5px">
                                <cp-button type="button" class="button--thin" @click="removeMedia">Remove</cp-button>
                            </div>
                        </div>
                        <OpenGraphPreview v-if="comment" :content="comment" />
                    </cp-grid-item>
                    <cp-grid-item
                        v-if="this.data.type_comment !== 'endorse'"
                        :span="isEditingReply || $root.isMobile ? 12 : 2"
                        style="display: flex; justify-content: flex-end; align-items: flex-start;"
                    >
                        <div v-if="!isEditingReply">
                            <cp-button v-if="authUser && authUser.id == data.user_id" primary style="height: 30px; margin-bottom: 2px" @click="handleEditReply(data.id)" :disabled="loadingUpdate"
                                >Edit</cp-button
                            >
                            <cp-button primary v-if="(authUser && authUser.id == data.user_id) || userAdmin" style="height: 30px" @click="deleteComment(data.id, 'reply')" :disabled="loadingDelete"> Delete </cp-button>
                        </div>
                    </cp-grid-item>
                </cp-grid>
            </cp-grid-item>
            <cp-grid-item :span="$root.isMobile ? 2 : 1" v-margin="0" />
            <cp-grid-item :span="$root.isMobile ? 10 : 11" v-margin="0">
                <div v-if="authUser && authUser.id !== data.user_id" style="margin-left: 10px">
                    <span>
                        <span @click="handleEndorseComment" :class="[endorseClass, this.endorseComment ? 'btn-green-enable white-color' : 'btn-green-disable black-color']"
                            >Endorse</span
                        >
                        <span @click="handleProtestComment" :class="[protestClass, this.protestComment ? 'btn-red-enable white-color' : 'btn-red-disable black-color']">Protest</span>
                        <span @click="handleReply" class="content-2 reply mr-5">Reply</span>
                    </span>
                    <div v-if="replyComment">
                        <cp-comment-input :send="sendReply" style="margin-bottom: 10px" :tag="data"></cp-comment-input>
                    </div>
                </div>
            </cp-grid-item>

            <cp-dialog v-if="showGifsModal">
                <cp-modal-gifs @close="handleGifsModal" :selectedGif="selectedGif"></cp-modal-gifs>
            </cp-dialog>
        </cp-grid>
    </div>
</template>

<style scoped>
.button-show-more {
    color: #ff4814;
    font-size: 16px;
    margin: 0 0 0 8px;
    cursor: pointer;
}
.button-show-more:hover {
    text-decoration: underline;
}
.video {
    max-width: 100%;
    max-height: 300px !important;
}
.gif {
    max-width: 300px;
    max-height: 300px;
}
.box-comment {
    display: block;
    resize: none;
    overflow: auto;
    border-style: hidden;
    width: 100%;
    outline: none;
    margin-top: 3px;
    padding: 5px;
}
.overflow {
    overflow-wrap: anywhere;
}
.box-reply {
    margin-top: 10px;
}
.reply {
    cursor: pointer;
}
.heading-4 {
    font-size: 20px;
}
div.social-feed-post-profile-wrapper {
    display: flex;
    flex-direction: row;
}
div.social-feed-post-profile-wrapper .details-wrapper {
    display: flex;
    flex-direction: column;
    padding-left: 10px;
}
.heading-4 {
    font-size: 20px;
}
div.social-feed-post-profile-wrapper .profile-name {
    font-size: 1.3em;
    font-weight: 600;
    padding: 0px;
    padding-right: 5px;
    margin: 1px;
}

div.social-feed-post-profile-wrapper .post-time {
    color: #666;
}

img.social-feed-post-img {
    max-width: 100%;
    max-height: 100%;
    min-width: 100%;
}
span.social-feed-default-img {
    display: flex;
    align-items: center;
    justify-content: center;
}
a.social-feed-post-link {
    display: block;
    padding-top: 10px;
    font-size: 1.1em;
}
.profile-img {
    width: 45px;
    height: 45px;
}

div.social-feed-post-wrapper {
    width: 100%;
    padding: 0.5em;
    margin-bottom: 0em;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: auto;
    border: 0px;
}
div.social-feed-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}
.social-feed-post-wrapper > * {
    width: 100%;
}
.mini-recipient {
    background-color: #efefef;
    border-radius: 4px;
    margin-bottom: 4px !important;
}
div.social-feed-box-wrapper.mobile img.social-feed-post-img {
    min-height: 45vh;
    object-fit: cover;
}
.social-feed-default-img {
    background: #ffe3da;
    color: var(--highlight);
}
div.social-feed-box-wrapper.mobile div.social-feed-post-wrapper {
    padding: 0.7em;
}
div.social-feed-post-img-placeholder {
    min-height: 400px;
    background: rgb(233, 94, 54);
    background: linear-gradient(180deg, rgba(233, 94, 54, 1) 65%, rgba(254, 130, 94, 1) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
}
header.social-feed-title-header {
    text-align: center;
    margin: 30px 0px;
}
div.social-feed-post-description {
    padding-top: 10px;
}
video.candidate-video-player {
    width: 100%;
    height: auto;
}
.profile-img.social-feed-default-img svg {
    margin-top: 10px;
}

.social-feed-sidebar {
    position: fixed;
}

.header-label {
    font-size: 16px;
    font-family: 'proxima-nova', Gotham, Helvetica, sans-serif;
    font-weight: 600;
    color: #121212;
}

.mobile-fixed-bottom-sidebar .social-feed-right-sidebar {
    padding: 15px;
    position: relative;
    max-width: 100% !important;
}

.small-desktop-right-sidebar .social-feed-right-sidebar {
    max-width: 12.2vh;
}

.small-desktop-right-sidebar .title-3 hr {
    display: none;
}

.mobile-fixed-bottom-sidebar {
    position: fixed;
    background: white;
    width: 100% !important;
    bottom: 0px;
    left: 0px;
    margin: 0px;
}
.btn {
    border: 1px;
    text-shadow: none;
    text-decoration: none !important;
    box-shadow: none;
    font-family: 'proxima-nova', Gotham, Helvetica, sans-serif;
    font-weight: 400;
    border-radius: 5px;
    box-sizing: border-box;
    display: inline-block;
    font-size: 16px;
    line-height: 1;
    padding: 0.3em 0.5em 0.28em;
    text-align: center;
}
.btn-green-enable {
    background: #22bb69;
}
.btn-red-enable {
    background: #f53c3c;
}
.btn-green-disable {
    background: var(--white);
    border: 1px solid rgba(34, 187, 105, 0.58);
}
.btn-red-disable {
    background: var(--white);
    border: 1px solid rgba(187, 34, 34, 0.58);
}
.reply-item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
@media only screen and (min-width: 1024px) and (max-width: 1366px) {
    .gif {
        max-width: 200px;
        max-height: 200px;
    }
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
    .box-comment {
        width: 97%;
    }
}
@media only screen and (max-width: 767px) {
    .gif {
        width: 100%;
        max-height: 110px;
    }
    .box-comment {
        width: 93%;
    }
}
@media screen and (max-width: 450px) {
    .reply-item-header {
        flex-direction: column;
        align-items: stretch;
    }
    
}
</style>
